import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import "./BlogDetailPage.css";
import NavBar from "../NavBar"
import Footer from "../Footer";
// import ReplyForm from '../../Common/BlogReplyForm';
import {blog_detail} from "../../data";

import ReplyForm from '../../Common/BlogReply';

function App() {
  return <X09BlogsDetailsPageMobile {...x09BlogsDetailsPageMobileData} />;
}

export default App;

function X09BlogsDetailsPageMobile(props) {
  const {
    text320,
    rectangle76,
    address,
    text321,
    rectangle97,
    rectangle98,
    followUs,
    f1,
    overlapGroup,
    vector2,
    vector3,
    line56,
    ellipse105,
    spanText,
    spanText2,
    text323,
    line57,
    leaveAReply,
    frame145Props,
    textInputsNormal32Props,
    textInputsNormal322Props,
    textInputsNormal323Props,
    textInputsNormal324Props,
    button11Props,
    group2122Props,
  } = props;

  return (
    <div className="bdpm-container-center-horizontal">
      <div className="bdpm-x09-blogs-details-page-mobile screen">
        {/* <Frame145 group86Props={frame145Props.group86Props} iconMenuProps={frame145Props.iconMenuProps} /> */}
        <NavBar/>
        <h1 className="bdpm-text-1 bdpm-valign-text-middle bdpm-typographyheadlineh4-extrabold-24">{text320}</h1>
        {/* <img className="bdpm-rectangle-76" src={rectangle76} /> */}
        <img className="bdpm-rectangle-76" src={blog_detail.BlogDetailHeader} />
        <div className="bdpm-group-196">
          <div className="bdpm-address bdpm-valign-text-middle bdpm-typography-body-smalltext-14-regular">{address}</div>
          <p className="bdpm-text-2 bdpm-typography-body-smalltext-14-regular">{text321}</p>
        </div>
        <div className="bdpm-frame-1636">
          {/* <img className="bdpm-rectangle-97" src={rectangle97} /> */}
          <img className="bdpm-rectangle-97" src={blog_detail.BlogDetailCard1} />
          {/* <img className="bdpm-rectangle-98" src={rectangle98} /> */}
          <img className="bdpm-rectangle-98" src={blog_detail.BlogDetailCard2} />
          <div className="bdpm-frame-1645">
            <div className="bdpm-follow-us bdpm-valign-text-middle bdpm-typographybody16-regular">{followUs}</div>
            <div className="bdpm-frame-1561">
              <div className="bdpm-facebook-app-symbol">
                <img className="bdpm-f-1" src={f1} />
              </div>
              <div className="bdpm-instagram">
                <div className="bdpm-overlap-group" style={{ backgroundImage: `url(${overlapGroup})` }}>
                  <img
                    className="bdpm-vector"
                    src="/Images/Blogs_detail/instagram2.svg"
                  />
                  <img className="bdpm-vector-1" src={vector2} />
                </div>
              </div>
              <div className="bdpm-twitter">
                <img className="bdpm-vector-2" src={vector3} />
              </div>
            </div>
          </div>
        </div>
        <div className="bdpm-frame-200">
          <img className="bdpm-line-56" src={line56} />
          <div className="bdpm-frame-1646">
            {/* <img className="bdpm-ellipse-105" src={ellipse105} /> */}
            <img className="bdpm-ellipse-105" src={blog_detail.BlogDetailWriter} />
            <div className="bdpm-frame-199">
              <div className="bdpm-text-3 bdpm-valign-text-middle bdpm-typographyheadlineh5-extrabold-20">
                <span>
                  <span className="bdpm-span0 bdpm-typographyheadlineh5-extrabold-20">{spanText}</span>
                  <span className="bdpm-span1 bdpm-typographyheadlineh5-extrabold-20">{spanText2}</span>
                </span>
              </div>
              <p className="bdpm-text-4 bdpm-typographybodysmall-12-regular">{text323}</p>
            </div>
          </div>
          <img className="bdpm-line-57" src={line57} />
        </div>
        <div className="bdpm-frame-1649">
          <div className="bdpm-leave-a-reply bdpm-valign-text-middle bdpm-typographyheadlineh4-extrabold-24">{leaveAReply}</div>
          <ReplyForm />
          {/* <div className="bdpm-frame-1648">
            <TextInputsNormal32 frame122Props={textInputsNormal32Props.frame122Props} />
            <div className="bdpm-frame-1647">
              <TextInputsNormal32
                className={textInputsNormal322Props.className}
                frame122Props={textInputsNormal322Props.frame122Props}
              />
              <TextInputsNormal32
                className={textInputsNormal323Props.className}
                frame122Props={textInputsNormal323Props.frame122Props}
              />
              <TextInputsNormal32
                className={textInputsNormal324Props.className}
                frame122Props={textInputsNormal324Props.frame122Props}
              />
            </div>
          </div> */}
          {/* <Button11>{button11Props.children}</Button11> */}
        </div>
        <Group2122
          group862Props={group2122Props.group862Props}
          group872Props={group2122Props.group872Props}
          group322Props={group2122Props.group322Props}
          frame5Props={group2122Props.frame5Props}
        />
      </div>
    </div>
  );
}


function Frame145(props) {
  const { group86Props, iconMenuProps } = props;

  return (
    <div className="bdpm-frame-145">
      <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
      <IconMenu vector2={iconMenuProps.vector2} vector3={iconMenuProps.vector3} />
    </div>
  );
}


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="bdpm-group-86">
      <White src={whiteProps.src} />
      <img className="bdpm-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="bdpm-white">
      <img className="bdpm-vector-3" src={src} />
    </div>
  );
}


function IconMenu(props) {
  const { vector2, vector3 } = props;

  return (
    <div className="bdpm-icon-menu">
      <img
        className="bdpm-vector-5"
        src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg"
      />
      <img className="bdpm-vector-4" src={vector2} />
      <img className="bdpm-vector-4" src={vector3} />
    </div>
  );
}


function TextInputsNormal32(props) {
  const { className, frame122Props } = props;

  return (
    <div className={`bdpm-text-inputs-normal-1 ${className || ""}`}>
      <Frame122 className={frame122Props.className}>{frame122Props.children}</Frame122>
    </div>
  );
}


function Frame122(props) {
  const { children, className } = props;

  return (
    <div className={`bdpm-frame-1-1 bdpm-border-1px-light-grey ${className || ""}`}>
      <div className="bdpm-text-i27326948671 inter-normal-sonic-silver-14px">{children}</div>
    </div>
  );
}


function Button11(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(x27326957TimelineData);
  }, []);

  return (
    <div className="bdpm-x27326957 bdpm-component bdpm-component-wrapper not-ready">
      <div className="bdpm-master-button-T9jqxu">
        <div className="bdpm-button-i2732695751-cdIAdO bdpm-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const x27326957TimelineData = [
  {
    initial_state_name: "Property-1=Primary",
    root_element: ".bdpm-x27326957",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


function Group2122(props) {
  const { group862Props, group872Props, group322Props, frame5Props } = props;

  return (
    // <div className="bdpm-group-212">
      /* <div className="bdpm-flex-row">
        <Group8622 group85={group862Props.group85} />
        <Group872
          facebookAppSymbolProps={group872Props.facebookAppSymbolProps}
          facebookAppSymbolProps2={group872Props.facebookAppSymbolProps2}
          twitterProps={group872Props.twitterProps}
        />
      </div>
      <Group322 {...group322Props} />
      <Frame5
        quickLinks={frame5Props.quickLinks}
        frame140Props={frame5Props.frame140Props}
        frame1402Props={frame5Props.frame1402Props}
        frame1403Props={frame5Props.frame1403Props}
      /> */
      <Footer/>
    // </div>
  );
}


function Group8622(props) {
  const { group85 } = props;

  return (
    <div className="bdpm-group-86-1">
      <div className="bdpm-white-1">
        <img
          className="bdpm-vector-6"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-148@2x.svg"
        />
      </div>
      <img className="bdpm-group-85-1" src={group85} />
    </div>
  );
}


function Group872(props) {
  const { facebookAppSymbolProps, facebookAppSymbolProps2, twitterProps } = props;

  return (
    <div className="bdpm-group-87">
      <FacebookAppSymbol src={facebookAppSymbolProps.src} />
      <Instagram2 overlapGroup1={facebookAppSymbolProps2.overlapGroup1} vector2={facebookAppSymbolProps2.vector2} />
      <Twitter src={twitterProps.src} />
    </div>
  );
}


function FacebookAppSymbol(props) {
  const { src } = props;

  return (
    <div className="bdpm-facebook-app-symbol-1">
      <img className="bdpm-f-1-1" src={src} />
    </div>
  );
}


function Instagram2(props) {
  const { overlapGroup1, vector2 } = props;

  return (
    <div className="bdpm-instagram-1">
      <div className="bdpm-overlap-group-1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
        <img
          className="bdpm-vector-7"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-18@2x.svg"
        />
        <img className="bdpm-vector-8" src={vector2} />
      </div>
    </div>
  );
}


function Twitter(props) {
  const { src } = props;

  return (
    <div className="bdpm-twitter-1">
      <img className="bdpm-vector-9" src={src} />
    </div>
  );
}


function Group322(props) {
  const { place, overlapGroup, phone, overlapGroup1, vector2, text165, text164, contactWebuildCom } = props;

  return (
    <div className="bdpm-group-32">
      <div className="bdpm-place bdpm-valign-text-middle bdpm-typographyheadlineh5-extrabold-20">{place}</div>
      <div className="bdpm-flex-row-1">
        <div className="bdpm-flex-col">
          <div className="bdpm-map-pin-1">
            <div className="bdpm-overlap-group-2" style={{ backgroundImage: `url(${overlapGroup})` }}>
              <img
                className="bdpm-vector-10"
                src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-21@2x.svg"
              />
            </div>
          </div>
          <div className="bdpm-phone" style={{ backgroundImage: `url(${phone})` }}></div>
          <div className="bdpm-mail">
            <div className="bdpm-overlap-group1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
              <img className="bdpm-vector-11" src={vector2} />
            </div>
          </div>
        </div>
        <div className="bdpm-flex-col-1">
          <p className="bdpm-text-6 bdpm-typography-body-smalltext-14-regular">{text165}</p>
          <div className="bdpm-flex-col-item bdpm-valign-text-middle bdpm-typography-body-smalltext-14-regular">{text164}</div>
          <div className="bdpm-flex-col-item bdpm-valign-text-middle bdpm-typography-body-smalltext-14-regular">
            {contactWebuildCom}
          </div>
        </div>
      </div>
    </div>
  );
}


function Frame5(props) {
  const { quickLinks, frame140Props, frame1402Props, frame1403Props } = props;

  return (
    <div className="bdpm-frame-5">
      <div className="bdpm-quick-links bdpm-valign-text-middle bdpm-typographyheadlineh5-extrabold-20">{quickLinks}</div>
      <div className="bdpm-frame-4">
        <Frame140 aboutUs={frame140Props.aboutUs} projects={frame140Props.projects} />
        <Frame140
          aboutUs={frame1402Props.aboutUs}
          projects={frame1402Props.projects}
          className={frame1402Props.className}
        />
        <Frame140
          aboutUs={frame1403Props.aboutUs}
          projects={frame1403Props.projects}
          className={frame1403Props.className}
        />
      </div>
    </div>
  );
}


function Frame140(props) {
  const { aboutUs, projects, className } = props;

  return (
    <div className={`bdpm-frame-140 ${className || ""}`}>
      <div className="bdpm-about-us bdpm-valign-text-middle bdpm-typographybody16-regular">{aboutUs}</div>
      <div className="bdpm-projects bdpm-valign-text-middle bdpm-typographybody16-regular">{projects}</div>
    </div>
  );
}

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85-1@2x.svg",
    whiteProps: whiteData,
};

const iconMenuData = {
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
};

const frame145Data = {
    group86Props: group86Data,
    iconMenuProps: iconMenuData,
};

const frame122Data = {
    children: "Comment",
    className: "",
};

const textInputsNormal32Data = {
    frame122Props: frame122Data,
};

const frame1222Data = {
    children: "Name",
    className: "bdpm-frame-1-2",
};

const textInputsNormal322Data = {
    className: "bdpm-text-inputs-normal-2",
    frame122Props: frame1222Data,
};

const frame1223Data = {
    children: "Email",
    className: "bdpm-frame-1-3",
};

const textInputsNormal323Data = {
    className: "bdpm-text-inputs-normal",
    frame122Props: frame1223Data,
};

const frame1224Data = {
    children: "Phone Number",
    className: "bdpm-frame-1",
};

const textInputsNormal324Data = {
    className: "bdpm-text-inputs-normal",
    frame122Props: frame1224Data,
};

const button11Data = {
    children: "POST COMMENT",
};

const group8622Data = {
    group85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85-2@2x.svg",
};

const facebookAppSymbolData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-1@2x.svg",
};

const instagram2Data = {
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-154@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-19@2x.svg",
};

const twitterData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-157@2x.svg",
};

const group872Data = {
    facebookAppSymbolProps: facebookAppSymbolData,
    facebookAppSymbolProps2: instagram2Data,
    twitterProps: twitterData,
};

const group322Data = {
    place: "Contact",
    overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-20@2x.svg",
    phone: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-14@2x.svg",
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-27@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-16@2x.svg",
    text165: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
    text164: "+91 8976535221, +91 8755645342",
    contactWebuildCom: "contact@webuild.com",
};

const frame140Data = {
    aboutUs: "About Us",
    projects: "Projects",
};

const frame1402Data = {
    aboutUs: "Gallery",
    projects: "Knowledge Transfer",
    className: "bdpm-frame-14-1",
};

const frame1403Data = {
    aboutUs: "Blogs",
    projects: "FAQ’s",
    className: "bdpm-frame-14",
};

const frame5Data = {
    quickLinks: "Quick Links",
    frame140Props: frame140Data,
    frame1402Props: frame1402Data,
    frame1403Props: frame1403Data,
};

const group2122Data = {
    group862Props: group8622Data,
    group872Props: group872Data,
    group322Props: group322Data,
    frame5Props: frame5Data,
};

const x09BlogsDetailsPageMobileData = {
    text320: "Lorem Ipsum passages of Lorem Ipsum available",
    rectangle76: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-76-4@2x.png",
    address: "5 June 2021",
    text321: <>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo, ac tincidunt sem pharetra nec. Nunc faucibus ipsum vel metus aliquam, interdum feugiat massa viverra. Donec velit magna, sodales sed convallis eu, egestas vel nisl. Etiam fermentum felis ac risus scelerisque, ac euismod diam finibus. Suspendisse lacus sem, gravida vestibulum ligula et, pulvinar mattis purus.<br /><br />Etiam fermentum felis ac risus scelerisque, ac euismod diam finibus. Suspendisse lacus sem, gravida vestibulum ligula et, pulvinar mattis purus. Phasellus mollis molestie ante sed rhoncus.<br /><br />Sed eu faucibus libero. Nunc at libero eget massa lobortis consectetur vel eu ligula. Suspendisse est mauris, fermentum id pellentesque ut, pharetra quis risus. Aliquam placerat orci turpis, quis venenatis massa lobortis a. Integer nec magna erat. Nullam vel dui vel purus consequat fermentum. Donec rhoncus convallis erat sit amet vestibulum. Duis lacinia, purus eget fermentum volutpat, justo ipsum mattis risus, a efficitur sapien nisi nec augue.</>,
    rectangle97: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-97-1@2x.png",
    rectangle98: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-98-1@2x.png",
    followUs: "Share:",
    f1: "/Images/Blogs_detail/facebook.svg",
    overlapGroup: "/Images/Blogs_detail/instagram1.svg",
    vector2: "/Images/Blogs_detail/instagram3.svg",
    vector3: "/Images/Blogs_detail/twiter.svg",
    line56: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-56-1@2x.svg",
    ellipse105: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/ellipse-105@2x.png",
    spanText: "Written by:",
    spanText2: " Darlene Robertson",
    text323: "Donec vitae mi metus. Vestibulum ac aliquam ligula. Sed vestibulum eu mi in finibus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.",
    line57: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-56-1@2x.svg",
    leaveAReply: "Leave a reply",
    frame145Props: frame145Data,
    textInputsNormal32Props: textInputsNormal32Data,
    textInputsNormal322Props: textInputsNormal322Data,
    textInputsNormal323Props: textInputsNormal323Data,
    textInputsNormal324Props: textInputsNormal324Data,
    button11Props: button11Data,
    group2122Props: group2122Data,
};

